import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { parse, format } from 'date-fns';
import { uk } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const Notification = ({
  id,
  createdAt,
  read_at,
  image,
  body,
  heading,
  action,
  created_at,
  firstUnreadNotificationId,
  setSeenNotificationsId,
  seenNotificationsId
}) => {
  const { t } = useTranslation();
  const { ref, inView: isVisible } = useInView({ rootMargin: '0px' });
  const currentYear = new Date().getFullYear();

  const handleMore = (link) => {
    if (link) window.open(link, '_blank');
  };

  const formatDateWithTime = (dateStr) => {
    const date = parse(dateStr, 'yyyy-MM-dd HH:mm:ss', new Date());
    return format(date, 'd MMMM yyyy • HH:mm', { locale: uk });
  };

  const formatDate = (dateStr, includeYear) => {
    const date = parse(dateStr, 'yyyy-MM-dd HH:mm:ss', new Date());
    if (includeYear) {
      return format(date, 'd MMMM yyyy', { locale: uk });
    }
    return format(date, 'd MMMM', { locale: uk });
  };

  useEffect(() => {
    if (isVisible && !read_at) {
      setSeenNotificationsId([...seenNotificationsId, `${id}`]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  const getActionButton = () => {
    switch (true) {
      case action?.type === 'link': {
        return (
          <button
            type="button"
            className="Btn Btn--primary action-link"
            onClick={() => handleMore(action?.data?.url)}
          >
            {action?.data?.caption || t('pushes.proceed')}
          </button>
        );
      }
      default:
        return null;
    }
  };

  return (
    <div key={id} className="notification" ref={ref}>
      <div className="notification__header">
        {created_at ? (
          <p className="notification__header__creation-date">
            {created_at?.includes(String(currentYear))
              ? formatDate(created_at)
              : formatDate(created_at, true)}
          </p>
        ) : null}
        {firstUnreadNotificationId === id && (
          <div className="notification__header__new-messages">
            {t('pushes.newNotifications')}
          </div>
        )}
        {image ? (
          <div className="notification__header__img">
            <img src={image} alt={heading} />
          </div>
        ) : null}
      </div>
      <div className="notification__info">
        {createdAt ? (
          <p className="notification__info__created-at">{formatDateWithTime(createdAt)}</p>
        ) : null}
        <p className="notification__info__title">{heading}</p>
        <p
          className="notification__info__message"
          dangerouslySetInnerHTML={{ __html: body ? body.replace(/\n/g, '<br>') : '' }}
        />
      </div>
      {action ? getActionButton() : null}
    </div>
  );
};

Notification.propTypes = {
  createdAt: PropTypes.string,
  read_at: PropTypes.string,
  created_at: PropTypes.string,
  image: PropTypes.string,
  id: PropTypes.number.isRequired,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  firstUnreadNotificationId: PropTypes.number,
  setSeenNotificationsId: PropTypes.func.isRequired,
  seenNotificationsId: PropTypes.array.isRequired,
  action: PropTypes.shape({
    type: PropTypes.oneOf(['link']).isRequired,
    data: PropTypes.shape({
      url: PropTypes.string.isRequired,
      caption: PropTypes.string.isRequired
    }).isRequired
  })
};

export default Notification;
